import { useCallback } from 'react';
import { AddStandardItemModal } from '@/components/modals/AddStandardItemModal';

export interface ViolationTypeOption {
  code: number;
  value: string;
}

export interface AddStandardViolationTypeModalProps {
  open: boolean;
  availableViolationTypes: ViolationTypeOption[];
  loading?: boolean;
  theme?: string;
  onSave: (data: { violationTypeCodes: number[] }) => void;
  onCancel: () => void;
}

export function AddStandardViolationTypeModal({
  open,
  availableViolationTypes = [],
  loading,
  theme,
  onSave,
  onCancel,
}: AddStandardViolationTypeModalProps) {
  const handleSave = useCallback((selectedCodes: number[]) => {
    onSave({ violationTypeCodes: selectedCodes });
  }, [onSave]);

  return (
    <AddStandardItemModal
      open={open}
      availableItems={availableViolationTypes}
      loading={loading}
      itemLabelKey="value"
      itemValueKey="code"
      title="Add Standard Violation Type"
      fieldLabel="Violation types to add"
      placeholder="Select Violation Types..."
      requiredMessage="Violation type(s) required."
      theme={theme}
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
}

(window as any).AddStandardViolationTypeModalReact = AddStandardViolationTypeModal;
